export default __webpack_public_path__ + "static/games_library-9cbdcc4aef03ab1350544cda90ae9fdc.png";